import _objectSpread from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import 'intersection-observer';
import { isEqual } from 'lodash-es';
import { createReporter } from './reporter';
import { getReportType } from './util';
export { createReporter } from './reporter';
/**
 * 创建指令
 * @param {Vue.VueConstructor} Vue
 * @param {{ pv: VftReport.ReporterInstance, event: VftReport.ReporterInstance }} reporter
 * @param {IntersectionObserver} observer
 *
 * @return {Vue.DirectiveOptions}
 */

export function createDirective(Vue, reporter, observer) {
  return {
    /**
     * @type {VftReport.DirectiveFunction}
     */
    bind: function bind(el, binding) {
      if (!binding.value) {
        console.warn('[v-report:bind] 上报参数为空', el);
        return;
      }

      var type = getReportType(binding.modifiers);
      var params = binding.value;

      if (type !== 'module' && !binding.arg && !params.f_module) {
        console.warn('[v-report:bind] f_module字段为空', el);
        return;
      }

      el.report = {
        type: type,
        params: params
      };

      if (type === 'module') {
        el.report.params.f_type = 1;
      } else {
        el.report.params = _objectSpread({
          f_module: binding.arg
        }, el.report.params);
      }

      if (['module', 'all', 'expose'].includes(type)) {
        Vue.nextTick(function () {
          el.observed = true;
          observer.observe(el);
        });
      }

      if (['all', 'click'].includes(type)) {
        el.report.click = function () {
          reporter.event.click(el.report.params);
        };

        el.addEventListener('click', el.report.click, true);
      }
    },

    /**
     * @type {VftReport.DirectiveFunction}
     */
    update: function update(el, binding, vnode) {
      if (!binding.value) {
        if (el.observed) {
          el.observed = false;
          observer.unobserve(el);
        }

        if (el.report && el.report.click) {
          el.removeEventListener('click', el.report.click, true);
          el.report.click = null;
        }

        return;
      }

      var type = getReportType(binding.modifiers);
      var params = binding.value;

      if (type !== 'module' && !binding.arg && !params.f_module) {
        console.warn('[v-report:update] f_module字段为空', el);
        return;
      }

      if (type !== 'module' && binding.arg) {
        params.f_module = binding.arg;
      }

      var innerText = el.innerText;
      Vue.nextTick(function () {
        if (el.report && isEqual(el.report.params, params) && (type === 'module' || innerText === vnode.elm.innerText)) {
          return;
        }

        if (!el.report) {
          el.report = {
            type: type,
            params: params
          };
        } else {
          el.report.params = Object.assign({}, el.report.params, params);
        }

        if (binding.modifiers.once) {
          return;
        }

        if (['module', 'all', 'expose'].includes(type)) {
          if (el.observed) {
            observer.unobserve(el);
          }

          observer.observe(el);
        }
      });
    },

    /**
    * @type {VftReport.DirectiveFunction}
    */
    unbind: function unbind(el) {
      if (el.report && el.report.click) {
        el.removeEventListener('click', el.report.click, true);
        el.report.click = null;
      }

      if (el.observed) {
        observer.unobserve(el);
      }
    }
  };
}
var reporter = {
  pv: null,
  event: null
};
export function useReporter() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'event';
  return reporter[type];
}
/**
 * @type {VftReport.ReportPluginObject}
 */

var plugin = {
  install: function install(Vue, options) {
    var config = options.config,
        extraParams = options.extraParams,
        delay = options.delay,
        observerOptions = options.observerOptions,
        silent = options.silent;
    reporter = {
      pv: null,
      event: createReporter({
        config: config.event,
        extraParams: extraParams,
        delay: delay,
        silent: silent
      })
    };
    var isSameReporter = !config.pv || isEqual(config.pv, config.event);
    reporter.pv = isSameReporter ? reporter.event : createReporter({
      config: config.pv,
      extraParams: extraParams,
      delay: delay,
      silent: silent
    });
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var target = entry.target,
            isIntersecting = entry.isIntersecting;

        if (isIntersecting) {
          // console.log(target, target.report)
          reporter.event.expose(target.report.params);
        }
      });
    }, Object.assign({}, {
      root: document.body,
      threshold: 0.1
    }, observerOptions || {}));
    Vue.directive('report', createDirective(Vue, reporter, observer));
    Vue.prototype.$report = {
      /**
       * 重新初始化
       */
      reinit: function reinit() {
        if (!isSameReporter) {
          reporter.pv.reinit();
        }

        reporter.event.reinit();
      },

      /**
       * 上报就绪
       */
      ready: function ready() {
        if (!isSameReporter) {
          reporter.pv.ready();
        }

        reporter.event.ready();
      },

      /**
       * 页面上报
       * @param {VftReport.ReportParams} params
       */
      pv: function pv(params) {
        reporter.pv.expose(Object.assign({
          f_type: 0
        }, params));
      },

      /**
       * 曝光上报
       * @param {VftReport.ReportParams} params
       */
      expose: function expose(params) {
        reporter.event.expose(params);
      },

      /**
       * 点击上报
       * @param {VftReport.ReportParams} params
       */
      click: function click(params) {
        reporter.event.click(params);
      },

      /**
       * 设置额外上报参数
       * @param {VftReport.ReportParams} params
       * @param {VftReport.ReporterType} type
       */
      setExtraParams: function setExtraParams() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'event';
        reporter[type].setExtraParams(params);
      }
    };
  }
};
export default plugin;